import { Trans } from '@lingui/react/macro'
import { Button, Result } from 'antd'

export interface LockOverlayProps {
  onUnlock: () => void
}

export function LockOverlay(props: LockOverlayProps) {
  return (
    <Result
      status="warning"
      title={<Trans>Gesperrt</Trans>}
      subTitle={<Trans>Die Sitzung wurde wegen Inaktivität gesperrt.</Trans>}
      extra={
        <Button type="primary" onClick={props.onUnlock}>
          <Trans>Entsperren</Trans>
        </Button>
      }
    />
  )
}
